/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { PriceRequestDetailsFragmentDoc } from './PriceRequestDetailsFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IUpdatePriceRequestQuoteMutationVariables = Types.Exact<{
  input: Types.IUpdatePriceRequestQuoteInput
}>

export type IUpdatePriceRequestQuoteMutation = { __typename?: 'Mutation' } & {
  updatePriceRequestQuote?: Types.Maybe<
    { __typename?: 'UpdatePriceRequestQuotePayload' } & Pick<
      Types.IUpdatePriceRequestQuotePayload,
      'success'
    > & {
        quotes?: Types.Maybe<
          { __typename?: 'PriceRequest' } & Pick<
            Types.IPriceRequest,
            | 'id'
            | 'additionalStops'
            | 'createdAt'
            | 'customerQuote'
            | 'customerQuoteType'
            | 'deliveryCity'
            | 'deliveryDropTrailer'
            | 'deliveryStartDate'
            | 'deliveryStartTime'
            | 'deliveryStateCode'
            | 'deliveryZipcode'
            | 'equipmentId'
            | 'externalId'
            | 'isTestQuote'
            | 'isDrop'
            | 'pickupCity'
            | 'pickupDropTrailer'
            | 'pickupStartDate'
            | 'pickupStartTime'
            | 'pickupStateCode'
            | 'pickupZipcode'
            | 'shipperApplicationId'
            | 'shipperMiles'
            | 'source'
            | 'isDoNotBidApplied'
            | 'updatedAt'
          > & {
              premiums?: Types.Maybe<
                { __typename?: 'PriceRequestPremium' } & Pick<
                  Types.IPriceRequestPremium,
                  'commodity' | 'quoteWithFuel' | 'quoteWithoutFuel'
                >
              >
              pricingResponse?: Types.Maybe<
                { __typename?: 'PricingResponse' } & Pick<
                  Types.IPricingResponse,
                  | 'datMiles'
                  | 'datRate'
                  | 'highDatRate'
                  | 'lowDatRate'
                  | 'tcm50'
                  | 'tcm40'
                  | 'tcm75'
                  | 'tcm25'
                >
              >
              shipperApplication?: Types.Maybe<
                { __typename?: 'ShipperApplication' } & Pick<
                  Types.IShipperApplication,
                  'id' | 'name'
                >
              >
              requestedBy?: Types.Maybe<
                { __typename?: 'User' } & Pick<
                  Types.IUser,
                  'firstName' | 'lastName' | 'id' | 'userType'
                >
              >
            }
        >
        errors: Array<{ __typename?: 'Error' } & Pick<Types.IError, 'key' | 'message'>>
      }
  >
}

export const UpdatePriceRequestQuoteDocument = gql`
  mutation UpdatePriceRequestQuote($input: UpdatePriceRequestQuoteInput!) {
    updatePriceRequestQuote(input: $input) {
      success
      quotes {
        ...PriceRequestDetails
      }
      errors {
        key
        message
      }
    }
  }
  ${PriceRequestDetailsFragmentDoc}
`
export type IUpdatePriceRequestQuoteMutationFn = Apollo.MutationFunction<
  IUpdatePriceRequestQuoteMutation,
  IUpdatePriceRequestQuoteMutationVariables
>

/**
 * __useUpdatePriceRequestQuoteMutation__
 *
 * To run a mutation, you first call `useUpdatePriceRequestQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePriceRequestQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePriceRequestQuoteMutation, { data, loading, error }] = useUpdatePriceRequestQuoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePriceRequestQuoteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IUpdatePriceRequestQuoteMutation,
    IUpdatePriceRequestQuoteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    IUpdatePriceRequestQuoteMutation,
    IUpdatePriceRequestQuoteMutationVariables
  >(UpdatePriceRequestQuoteDocument, options)
}
export type UpdatePriceRequestQuoteMutationHookResult = ReturnType<
  typeof useUpdatePriceRequestQuoteMutation
>
export type UpdatePriceRequestQuoteMutationResult = Apollo.MutationResult<
  IUpdatePriceRequestQuoteMutation
>
export type UpdatePriceRequestQuoteMutationOptions = Apollo.BaseMutationOptions<
  IUpdatePriceRequestQuoteMutation,
  IUpdatePriceRequestQuoteMutationVariables
>
